
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".9","d":"M28.386 14.562c2.607 1.55 2.607 5.324 0 6.875L6.526 34.44C3.86 36.026.481 34.105.481 31.002V4.996c0-3.102 3.379-5.024 6.045-3.438l21.86 13.004z","fill":"#fff"}})])
          )
        }
      }
    